/** The app-connection notices: an app connected, or its connection failed. */

import { translate } from "@/i18n";
import { storesNoticesMessages } from "@/i18n/messages/stores-notices";
import { useNotificationStore } from "@/stores/notification-store";

export function toastAppConnected(toolkitSlug: string, app: string): void {
  useNotificationStore.getState().addSystemToast({
    id: `composio-connected-${toolkitSlug}`,
    title: translate(storesNoticesMessages, "connectedTitle"),
    description: translate(storesNoticesMessages, "connectedDescription", {
      app,
    }),
    level: "info",
  });
}

export function toastAppError(
  toolkitSlug: string,
  app: string,
  reason: string,
): void {
  useNotificationStore.getState().addSystemToast({
    id: `composio-error-${toolkitSlug}-${Date.now()}`,
    title: translate(storesNoticesMessages, "connectionFailedTitle", { app }),
    description: reason,
    level: "error",
  });
}
